export
const name: string = "SsaoGeometryCutOff";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec3  a_position;
    attribute float a_visibility;
    attribute float a_manipulation;

    uniform mat4    u_view_projection;
    uniform mat4    u_view_matrix;
    uniform mat4    u_heightMatrix;
    uniform mat4    u_manipulator;
`;

export
const varyings: string = `
    varying vec3    v_position;
    varying float   v_visibility;
    varying vec4    v_relativePosition;
`;

export
const implementation: string = `
    void main()
    {
        v_visibility = a_visibility;
        vec4 position = vec4(a_position, 1.0) * a_visibility;
    #ifdef MANIPULATOR_ENABLED
        if (a_manipulation > 0.5) {
            position = u_manipulator * position;
        }
    #endif

        v_relativePosition = u_heightMatrix * position;

        v_position = vec4(u_view_matrix * position).xyz;

    #ifdef CLIPPING_PLANE
        setVaryingsForCPlane(position);
    #endif

        gl_Position = u_view_projection * position;

    #ifdef LOGDEPTH
        setVaryingsForLogarithmicDepthBuffer();
    #endif
    }
`;
